import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DiagnosisWebSocketService } from '../../service/diagnosis-web-socket.service';
import { Vehicle } from '../../../shared/model/vehicle';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { DiagnosisGeneralResult } from '../../../shared/model/diagnosis-general-result';
import { Coordinate } from '../../../shared/model/coordinate';
import { DiagnosisService } from '../../service/diagnosis.service';
import { DiagnosisType } from '../../../shared/model/diagnosis-type';

@Component({
  selector: 'tx-diagnosis',
  templateUrl: './diagnosis.component.html',
  styleUrls: ['./diagnosis.component.css']
})
export class DiagnosisComponent implements OnInit, AfterViewInit {
  private _vehicle: Vehicle;
  private _diagnosisType: DiagnosisType;
  private _run: boolean;
  private _diagnosisGeneralResult: DiagnosisGeneralResult;
  vehicles: Array<Vehicle>;
  coordinates: Array<Coordinate>;
  _applyCard: boolean;
  _showTitle: boolean;
  @Input() changeVehicle: boolean;
  running = true;
  diagnosisFinished = false;
  hasError = false;

  constructor(private _router: Router,
              private _diagnosisNotification: DiagnosisWebSocketService,
              private _route: ActivatedRoute,
              private _diagnosisService: DiagnosisService) {
    this.observeRestart();
    this.setEmptyEntities();
    this.setUpDiagnosisFinished();
    this.subscribeError();
  }

  ngOnInit() {
    this.getParams();
  }

  get vehicle() {
    return this._vehicle;
  }

  @Input()
  set vehicle(vehicle) {
    this._vehicle = vehicle;
    this._diagnosisType = vehicle.diagnosisType;
    this.changeVehicle = this.changeVehicle === undefined ? true : this.changeVehicle;
    try {
      this.runDiagnosis();
    } catch (e) {
      this.goBack();
    }
  }

  get run() {
    return this._run;
  }

  @Input()
  set run(run) {
    this._run = run;
  }

  get diagnosisGeneralResult() {
    return this._diagnosisGeneralResult;
  }

  @Input()
  set diagnosisGeneralResult(diagnosisGeneralResult) {
    this._diagnosisGeneralResult = diagnosisGeneralResult;

    if (!this._run) {
      this.getCoordinatesByDiagnosisId();
    }
  }

  get applyCard() {
    return this._applyCard;
  }

  @Input()
  set applyCard(applyCard) {
    this._applyCard = applyCard;
  }

  get showTitle() {
    return this._showTitle;
  }

  @Input()
  set showTitle(showTitle) {
    this._showTitle = showTitle;
  }

  get diagnosisType() {
    return this._diagnosisType;
  }

  @Input()
  set diagnosisType(diagnosisType) {
    this._diagnosisType = diagnosisType;
  }

  ngAfterViewInit() {
  }

  getParams() {
    this._route.params.subscribe(params => {
      if (params['data']) {
        const data = JSON.parse(params['data']);
        this.vehicle = Object.assign(new Vehicle(), data.vehicle);
        this.vehicles = Object.assign(new Array(), data.vehicles);
        this.showTitle = Object.assign(Boolean, data.showTitle);
      }
    });
  }

  runDiagnosis() {
    if (this.vehicle && this._run) {
      this._diagnosisNotification.run(this.vehicle);
    }
  }

  private getCoordinatesByDiagnosisId() {
    this._diagnosisService.getCoordinatesFromDiagnosis(this._diagnosisGeneralResult.id)
      .subscribe(
        (response: any) => {
          this.coordinates = Object.assign(new Array<Coordinate>(), JSON.parse(response._body));
        },
        error => this.coordinates = undefined
      );
  }

  getLastCoordinate() {
    if (this.coordinates === undefined || this.coordinates.length === 0) {
      return undefined;
    }
    return this.coordinates[this.coordinates.length - 1].position;
  }

  applyCardClass() {
    if (this._applyCard === undefined) {
      return true;
    } else {
      return this._applyCard;
    }
  }

  mustShowTitle() {
    if (this._showTitle === undefined) {
      return false;
    } else {
      return this._showTitle;
    }
  }

  goBack() {
    this._router.navigate(['diagnosis']);
    this._diagnosisNotification.back();
  }

  displayGeneralDiagnosis() {
    if (this._diagnosisType === undefined) {
      return true;
    } else {
      return this._diagnosisType === DiagnosisType.GENERAL;
    }
  }

  displaySimplifiedDiagnosis() {
    if (this._diagnosisType === undefined) {
      return false;
    } else {
      return this._diagnosisType === DiagnosisType.SIMPLIFIED;
    }
  }

  showRestartOption() {
    return !this.running && this.diagnosisFinished || this.hasError;
  }

  setUpDiagnosisFinished() {
    this._diagnosisNotification.response$
      .filter(response => response instanceof DiagnosisGeneralResult)
      .subscribe(response => {
          this.running = false;
          this.diagnosisFinished = true;
      });
  }

  restartDiagnosis() {
    this._diagnosisNotification.restart();
    this.hasError = false;
  }

  observeRestart() {
    this._diagnosisNotification.restart$
      .subscribe(() => {
        this.setEmptyEntities();
        this.running = true;
      });
  }

  subscribeError() {
    this._diagnosisNotification.error$
      .subscribe(() => {
        this.setEmptyEntities();
        this.running = false;
        this.hasError = true;
      });
  }

  private setEmptyEntities() {
    if (this._diagnosisGeneralResult === undefined) {
      this._diagnosisGeneralResult = new DiagnosisGeneralResult();
    }

    if (this._run === undefined) {
      this._run = true;
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/diagnosis/diagnosis.component.ts